"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _Workflow = _interopRequireDefault(require("settings-ui-sdk/QuoteAutomation/records/Workflow"));

var _isEmpty = _interopRequireDefault(require("transmute/isEmpty"));

var _actions = require("settings-ui-sdk/QuoteAutomation/actions");

var initialState = (0, _immutable.List)();

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.CreateWorkflowsActionTypes.SUCCESS:
      if ((0, _isEmpty.default)(action.payload.data)) {
        return state;
      }

      return state.concat(action.payload.data.map(function (workflow) {
        return new _Workflow.default(workflow);
      }));

    case _actions.DeleteWorkflowsActionTypes.SUCCESS:
      return state.clear();

    case _actions.FetchWorkflowsActionTypes.SUCCESS:
      if ((0, _isEmpty.default)(action.payload.data)) {
        return state;
      }

      return (0, _immutable.List)(action.payload.data).map(function (workflow) {
        return new _Workflow.default(workflow);
      });

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;